import { render } from "./ActieVoorstellen.vue?vue&type=template&id=146c21c6&scoped=true"
import script from "./ActieVoorstellen.vue?vue&type=script&lang=js"
export * from "./ActieVoorstellen.vue?vue&type=script&lang=js"

import "./ActieVoorstellen.vue?vue&type=style&index=0&id=146c21c6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\benja\\Desktop\\SKWinkelStarter\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-146c21c6"]])

export default __exports__